import car_key_icon from "@/assets/icons/home/maps/car-key.svg"
import fuel_pump_icon from "@/assets/icons/home/maps/fuel-pump.svg"
import truck_icon from "@/assets/icons/home/maps/truck.svg"
import play_icon from "@/assets/icons/home/maps/play.svg"
import alarm_icon from "@/assets/icons/home/maps/alarm.svg"
import cog_icon from "@/assets/icons/home/maps/cog.svg"

export const options = [
  {
    label: "Ignition",
    icon: car_key_icon
  },
  {
    label: "Fuel pump",
    icon: fuel_pump_icon
  },
  {
    label: "Doors",
    icon: truck_icon
  },
  {
    label: "History",
    icon: play_icon
  },
  {
    label: "Alarm",
    icon: alarm_icon
  },
  {
    label: "Settings",
    icon: cog_icon
  }
];

export const sliderItemSizes = {
  xl: {
    width: 60
  },
  lg: {
    width: 40
  },
  xs: {
    width: 25
  }
};

export const sliderStyles = {
  xs: {
    bottom: "6px"
  },
  lg: {
    bottom: "10px"
  },
  xl: {
    bottom: "15px"
  }
}
